import { DASHBOARD_REQUEST,DASHBOARD_REQUEST_ERROR, DASHBOARD_REQUEST_SUCCESS } from "../actionType/type";

const initialState = {
    data: null,
    isLoading: false,
    /* Kept, unlike every other slice here, because the dashboard renders a
       skeleton while `data` is null: without this a failed request would
       shimmer forever instead of falling back to the empty figures. */
    error: null,
    refreshPage:false
};

export const dashboardReducers = (state=initialState,action) => {
    let object;
    switch (action.type) {
        case DASHBOARD_REQUEST:
            object = {
                ...state,
                isLoading: true,
                error: null,
              }
            break
        case DASHBOARD_REQUEST_ERROR:
            object = {
                ...state,
                isLoading:false,
                error: action.payload ?? action.error ?? true
            }
            break
        case DASHBOARD_REQUEST_SUCCESS:
            object = {
                ...state,
                data:action.payload,
                isLoading:false
            }
            break
    
        default:
            object = state
            break
    }
    
    return object
}